exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Admin__root___1jQ-G {\n  padding: 0 12px;\n}\n\n.Admin__new___23kt5 {\n  margin-top: 16px;\n}\n\n.Admin__header___3fgk3 {\n  margin-bottom: 12px;\n  margin-top: 24px;\n}\n\n.Admin__header___3fgk3:first-child {\n  margin-top: 0;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Admin__root___1jQ-G",
	"new": "Admin__new___23kt5",
	"header": "Admin__header___3fgk3"
};